export const enum SCAFFOLDTYPES {
  MODULE = "module",
}
